import {
  FLOWPAGE_PATHS,
  LEFT_NAV_PATHS,
  PLATFORM_NAV_PATHS
} from '@dtx-company/true-common/src/constants/layout'
import { Routes } from '@dtx-company/true-common/src/constants/routes'
import { useAuthState } from '@dtx-company/inter-app/src/hooks/useAuthState'
import { matchesAnyRoute, matchesRoute } from '@dtx-company/true-common/src/utils/urls/matchesRoute'
import { usePathname } from 'next/navigation'
import { useRouter } from 'next/router'
import { useScreenSizeBreakpoints } from '@dtx-company/app/shared/common/src/hooks/useScreenSizeBreakpoints'

export function useNavigationRoutes(): {
  shouldShowPlatformTopNav: boolean
  shouldShowLeftNav: boolean
  isAuthRoute: boolean
  isFlowpageRoute: boolean
  isOnHomepage: boolean
  userIsLoggedInOnMobile: boolean
  currentPageIsPlatformRoute: boolean
  isAuthChecked: boolean
  isAuthenticated: boolean
} {
  const pathname = usePathname() ?? ''
  const { query } = useRouter()
  const isAuthRoute =
    matchesRoute(pathname, Routes.SIGN_IN) || matchesRoute(pathname, Routes.SIGN_UP)

  const { isAuthenticated, isAuthChecked } = useAuthState()

  const { isMobile } = useScreenSizeBreakpoints()
  const currentPageIsPlatformRoute = matchesAnyRoute(pathname, PLATFORM_NAV_PATHS)
  const shouldShowLeftNav = matchesAnyRoute(pathname, LEFT_NAV_PATHS)
  const userIsLoggedInOnMobile = Boolean(isAuthenticated) && isMobile
  const isCheckoutPage =
    matchesRoute(pathname, Routes.BUY_PLAN_PAGE) || matchesRoute(pathname, Routes.UPGRADE)
  const shouldShowPlatformTopNav = !isCheckoutPage || isAuthenticated
  const isOnHomepage = matchesRoute(pathname, Routes.INDEX)

  return {
    shouldShowPlatformTopNav,
    shouldShowLeftNav,
    isAuthRoute,
    isFlowpageRoute: Boolean(
      matchesAnyRoute(pathname, FLOWPAGE_PATHS) || (query.flowpage === 'true' && isAuthRoute)
    ),
    isOnHomepage,
    userIsLoggedInOnMobile,
    currentPageIsPlatformRoute,
    isAuthChecked,
    isAuthenticated
  }
}
